const nutritionist = {
  getList: 'nutritionist/getList',
  add: 'nutritionist/add',
  update: 'nutritionist/update',
  getAll: 'nutritionist/getall',
  assign: 'nutritionist/set'
}

export default nutritionist